export function pathToSurveyReport(surveyId: string) {
	return `/admin/survey/${surveyId}/report`
}

export function pathToSurveyReportDetails(surveyId: string, detailIndex: number) {
	return `/admin/survey/${surveyId}/report/details/${detailIndex}`
}
